import styles from './Paragraph.module.scss';
import { ReactNode } from 'react';

interface Props {
  children: string | ReactNode;
  spacing?: 'both' | 'bottom' | 'none' | 'top';
  textAlign?: 'start' | 'center' | 'end';
}

export function Paragraph(props: Props) {
  const { spacing = 'both', textAlign = 'start' } = props;
  const className = [
    styles['paragraph'],
    styles['paragraph-text-align-' + textAlign],
    styles['paragraph-spacing-' + spacing],
  ]
    .filter(Boolean)
    .join(' ');

  return <p className={className}>{props.children}</p>;
}
